import axios from 'axios';
import toastr from 'toastr';
export default {
    name: 'TwoFactorExplanation',
    props: {
        id: {
            type: Number
        }
    },
    data() {
        return {
            initialized: false,
        };
    },
    mounted() {

    },
    computed: {

    },
    methods: {
        fetch() {
            this.initialized = true;
        },
        dismiss() {
            this.$vuedals.dismiss();
        },
        saveChanges() {
            if (this.record.code == '' || this.record.code == null)
                toastr.error(this.$t('error.twofactorcode'), '');
            else {
                let saveAction = axios.post(APIURL + '/applicationuser/two-factor-verify/' + this.id, this.record);
                saveAction.then(resp => {
                    if (resp.data) {
                        toastr.success(this.$t('success.saveChanges'), '');
                        this.$vuedals.close();
                    }
                    else {
                        toastr.error(this.$t('error.invalid_code'), '');
                    }
                    //this.record = resp.data;
                });
            }
        }
    }
};